
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

import {
  UserCircleIcon,
  Bars3Icon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { ShieldCheck } from "lucide-react";
const Navbar = () => {
  const location = useLocation();
  const { user } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);
const LOGO_URL = import.meta.env.VITE_LOGO_URL;
  const navLinks = [
    {
      name: "Dashboard",
      path: "/dashboard",
    },
    {
      name: "Events",
      path: "/events-manager",
    },
    {
      name: "Users",
      path: "/users",
    },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <>
     <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200">

        <div className="h-20 w-full flex items-center">

          {/* Left Logo */}

          <div className="flex-1 pl-8">
            <Link to="/">
              <img
                src="https://res.cloudinary.com/bvpzaizf/image/upload/f_auto,q_auto,w_300,c_limit/v1787143638/logo2.png"
                alt="Logo"
                className="h-12 w-auto"
              />
            </Link>
          </div>

          

          <div className="flex-1 flex justify-end items-center pr-8 gap-3">

            <Link
              to="/profile"
              className="hidden md:flex items-center gap-2"
            >
              <UserCircleIcon className="w-9 h-9 text-[#1672B9]" />

              <span className="text-gray-700 text-sm">
                {user?.name || "Guest"}
              </span>
            </Link>

            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="md:hidden"
            >
              {mobileOpen ? (
                <XMarkIcon className="w-7 h-7 text-gray-700" />
              ) : (
                <Bars3Icon className="w-7 h-7 text-gray-700" />
              )}
            </button>

          </div>

        </div>

        {/* Blue Strip */}

        <div className="h-[6px] bg-[#1672B9]"></div>

      </header>

      {/* Mobile Menu */}

      {mobileOpen && (
        <div className="md:hidden bg-white border-b border-gray-200">

          {navLinks.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              onClick={() => setMobileOpen(false)}
              className={`block px-6 py-3
                ${
                  isActive(item.path)
                    ? "text-[#1672B9] font-semibold"
                    : "text-gray-700"
                }
              `}
            >
              {item.name}
            </Link>
          ))}

        </div>
      )}
    </>
  );
};

export default Navbar;

